import { PrimaryButton } from 'components/atoms';
import React from 'react';

import { SubmitButtonProps } from './types';

export const SubmitButton = ({ disabled = false, submitLabel }: SubmitButtonProps) => (
  <PrimaryButton disabled={disabled} type="submit" data-testid="form-submit">
    {submitLabel}
  </PrimaryButton>
);
